import React from 'react'
import { tagAxes, TagAxis, TagAxisId } from '@cpsy-rmap-project/tags'
import { MultipleSelectTags, HandleSelectTagsOption } from '../../molecules/MultipleSelectTags'
// eslint-disable-next-line import/no-cycle
import { ConditionBox, ConditionTitle } from '../SearchOptions'

export interface MultipleSelectTagsProps {
  title: string
  selectTags: Record<TagAxis['id'], string[]>
  handleSelectTags: (tagAxis: TagAxis['id'], options: HandleSelectTagsOption) => void
  verticalAxis?: TagAxisId
  horizontalAxis?: TagAxisId
  hideUnspecifiedTags?: boolean
}

export const AllAxesMultipleSelectTags = ({
  title,
  selectTags,
  handleSelectTags,
  verticalAxis,
  horizontalAxis,
  hideUnspecifiedTags
}: MultipleSelectTagsProps) => (
  <ConditionBox>
    <ConditionTitle style={{ display: 'block', marginBottom: '1em' }}>{title}:</ConditionTitle>
    {tagAxes.map(tagAxis => (
      <MultipleSelectTags
        key={tagAxis.id}
        tagAxisId={tagAxis.id}
        selectTags={selectTags}
        handleSelectTags={handleSelectTags}
        disableUpspecifiedTag={hideUnspecifiedTags ? [verticalAxis, horizontalAxis].includes(tagAxis.id) : false}
      />
    ))}
  </ConditionBox>
)
